module.exports = "<div class=widget__aside><div class=\"widget__banners flexslider\"><ul class=\"list-unstyled clearfix\"><li class=\"widget__banner-item d-flex justify-content-center\"><advertisement sh-ctrl=$ctrl.shCtrl type-content=espacios positions=2 page-name=PAG-19></advertisement></ul></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/shared/components/banners/side-banners/templates/side-banners-base.view.html
 ** module id = 775
 ** module chunks = 7
 **/